export enum NotificationType {
  OUT_OF_OFFICE_BACK_AT_OFFICE = 'OUT_OF_OFFICE_BACK_AT_OFFICE',
  WORKFLOW_STARTED = 'WORKFLOW_STARTED',
  SERVICE_TASK_CREATED = 'SERVICE_TASK_CREATED',
  WORKFLOW_COMPLETED = 'WORKFLOW_COMPLETED',
  SERVICE_TASK_OVERDUE = 'SERVICE_TASK_OVERDUE',
  WORKFLOW_OVERDUE = 'WORKFLOW_OVERDUE',
  SERVICE_TASK_COMPLETED = 'SERVICE_TASK_COMPLETED',
  EMPLOYEE_OFFBOARDING_FAILED = 'EMPLOYEE_OFFBOARDING_FAILED',
}
